function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/prop-types */
import React from 'react';
import dynamic from 'next/dynamic';

/**
 * Workaround to allow the dynamic import to receive a ref by converting it to a prop and then re-attaching as a ref after the import has completed.
 * See here for more information: https://github.com/vercel/next.js/issues/4957#issuecomment-413841689
 */
var VideoPlayer = dynamic(() => {
  return import('./index').then(mod => {
    var Component = mod.default;
    return props => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      ref: props.clonedRef
    }));
  });
});
var ForwardedRefVideoPlayer = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(VideoPlayer, _extends({}, props, {
    clonedRef: ref
  }));
});
export default ForwardedRefVideoPlayer;